import request from "../request";

export const createTeachingSuggestion = (curriculumId, lcId, levelId, data) =>
  request.post(`/assessment/${curriculumId}/learning-continuum/${lcId}/level/${levelId}/teaching-suggestion`, data).then((res) => res);

export const updateTeachingSuggestion = (curriculumId, lcId, levelId, id, data) =>
  request.put(`/assessment/${curriculumId}/learning-continuum/${lcId}/level/${levelId}/teaching-suggestion/${id}`, data).then((res) => res);

export const deleteTeachingSuggestion = (curriculumId, lcId, levelId, id) =>
  request.delete(`/assessment/${curriculumId}/learning-continuum/${lcId}/level/${levelId}/teaching-suggestion/${id}`).then((res) => res);